import { cva } from "class-variance-authority";
import ItemsTooltip, {
  type ItemsTooltipVariant,
} from "~/molecules/ItemsTooltip";

const moreTooltipVariants = cva(
  "flex shrink-0 items-center justify-center text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        category:
          "size-5 rounded-full bg-primary/10 hover:bg-primary/30 text-primary",
        tag: "rounded-full bg-tag-muted/50 px-1.5 py-0.5 text-tag font-semibold whitespace-nowrap hover:bg-tag-muted",
      },
    },
  },
);

interface Props {
  data: string[];
  variant?: ItemsTooltipVariant;
}

const MoreTooltip = ({ data, variant = "category" }: Props) => {
  if (data.length <= 1) return null;

  return (
    <ItemsTooltip items={data.slice(1)} variant={variant}>
      <span className={moreTooltipVariants({ variant })}>
        +{data.length - 1}
      </span>
    </ItemsTooltip>
  );
};

export default MoreTooltip;
